import { User } from '../../auth/authState';

const userHasPermission = (user: User | null, permissionName: string) => {
  if (!user) {
    return false;
  }

  return user.roles.includes(`mensajeria/${permissionName}`);
};

export default userHasPermission;
